import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '@environments/environment';
//import { Hub, HubManager } from 'src/app/pages/hubs/common/Hubs';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
let retryCount: number = 0;
let maxRetry: number = 2;
@Injectable({ providedIn: 'root' })
export class PredictiveWaitBlocker implements OnDestroy {
    static RECORD_LOCKED: string = 'tmHubRecordLocked';
    static HUB_Name: string = 'TMHub';
    queueID: any = null;
    cancelBtn: any = null;
    alertBox: any = null;
    waitMsg: any = null;
    timerText: any = null;
    timer: any = null;
    timerInterval: any = null;
    inbound: any = null;
    callID: any = null;
    notifications: any = null;
    notificationHolder: any = null;
    waitingTimeout: any = null;
    softPhone: any = null;
    pendingTimer: any = null;
    checkConnectedTimer: any = null;
    pendingOpen: any = null;
    phoneController: any = null;
    interactionType: any = null;
    interactionName: any = 'Call';
    statusSet: any = false;
    //AWS Migration - ONV-1456 ( Hardcoded s3bucket name of AWS environment )
    newCallSnd: any = new Audio("https://common.cts-connect.com/Audio/ding-ding.ogg");
    phoneEnabled = false;
    
    constructor(private tmQueueService: TmQueueService) {
        // super();
        //self = this;

        //HubManager.CONNECTIONSTARTED.subscribe(res => {
        //    console.log('TMHub Joined');
        //    self.join();
        //});

    }
    //getNotification(evt) {
    //    self.join();
    //}
    //@InboundAttribute
    public recordLocked(client: string, recordLock: any) {
        //if (this.QBRSecurity().clientShortName() == client && recordLock.LockingUserID !== this.Security().user().UserID) {
        //    this.dispatchEvent(TMHub.RECORD_LOCKED, recordLock);
        //}
    }
    open = function (_queueID: string, _inbound: boolean, _type: string): void {
        window.clearTimeout(this.pendingTimer);
        window.clearTimeout(this.checkConnectedTimer);
        if (this.waitMsg || this.PhoneEnabled()) {
            this.pendingOpen = null;
            this.inbound = !!_inbound;
            this.interactionType = _type;
            this.interactionName = (_type === 'InboundTextChat' || _type === 'InboundVideoChat') ? 'Chat' : 'Call';
            this.showPhoneMessaging((this.softPhone ? 'Connecting your softphone.' : (this.inbound ? ('Waiting for an inbound ' + this.interactionName.toLowerCase() + '.') : ('Retrieving the next ' + this.interactionName.toLowerCase() + '.'))) + '<br />Please wait...');
           // this.contentView().visible(!this.phoneController.phoneEnabled());
            // cls.superclass().open.apply(this, []);
            this.queueID = _queueID;
            this.callID = null;
            this.updateStatusSet(false);
            this.waitingForCall();
            this.checkConnectedTimer = setTimeout(this.checkCallConnected, 3000);
        } else {
            const self = this;
            this.pendingOpen = {
                queueID: _queueID,
                inbound: _inbound,
                type: _type
            };
            this.pendingTimer = window.setTimeout(function () {
                self.open(this.pendingOpen.queueID, this.pendingOpen.inbound, this.pendingOpen.type);
            }, 500);
        }
    }

    isOpen = function (): boolean {
        const isOpen: boolean = false;//cls.superclass().isOpen.apply(this, arguments);
        //return (isOpen || (phoneController && phoneController.phoneEnabled() && phoneController.showMessage() && !phoneController.showError()));

        return isOpen;
    }
    PhoneEnabled = function (value) {
        if (typeof value === 'boolean') {
            this.phoneEnabled = value;
            //updateViewPosition(phoneEnabled, externalSystem, externalSystemName);
            //this.visible(phoneEnabled);
            //return cls;
        }
        this.phoneEnabled = true;//Hardcoded
        return this.phoneEnabled;
    }
    //cls.Override.close = function (): void {
    //    window.clearTimeout(pendingTimer);
    //    window.clearTimeout(checkConnectedTimer);
    //    clearTimeout(waitingTimeout);
    //    hideTimer();
    //    if (alertBox)
    //        alertBox.close();
    //    cls.superclass().close.apply(this, arguments);
    //    if (phoneController.phoneEnabled())
    //        phoneController.showMessage(false);
    //}

    //cls.showNotification = function (msg: string, link?: string, confirmation?: boolean): im.NotificationItem {
    //    const newNotification: im.NotificationItem = new im.NotificationItem();
    //    newNotification.addEventListener(im.NotificationItem.CLOSE, eNotificationCloseHandler);
    //    notificationHolder.addSubView(newNotification);
    //    notifications.push(newNotification);
    //    newNotification.setContent(msg, link, confirmation);
    //    return newNotification;
    //}

    softPhoneConnected = function (): void {
        //showPhoneMessaging((inbound ? ('Waiting for an inbound ' + interactionName.toLowerCase() + '.') : ('Retrieving the next ' + interactionName.toLowerCase() + '.')) + '<br />Please wait...');
    }

    updateStatusSet = function (val: boolean): void {
        this.statusSet = val;
    }

    //cls.softPhoneDisconnected = function (): void {
    //    if (cls.isOpen()) {
    //        callID = null;
    //        showPhoneMessaging('Connecting your softphone.<br />Please wait...');
    //        cls.updateStatusSet(false);
    //        hideTimer();
    //        waitingForCall();
    //    }
    //}

    //cls.softPhone = function (value?: boolean): cls {
    //    if (typeof value === 'undefined')
    //        return softPhone;
    //    softPhone = !!value;
    //    return cls;
    //}

    //cls.callID = function (): string | null {
    //    return callID;
    //}

    hideTimer = function (): void {
        //clearInterval(timerInterval);
        // timer = 0;
        // timerText.text('').visible(false);
    }

    setTimerInterval = function (): void {
        //clearInterval(timerInterval);
        //timer = 0;
        //timerInterval = setInterval(function () {
        //    timer++;
        //    updateTimer();
        //}, 1000);
        //updateTimer();
    }

    updateTimer = function (): void {
        //  timerText.text(im.Utils.formatDuration(timer, 's')).visible(true);
    }

    eNotificationCloseHandler = function (e: any): void {
        //let notification: this.NotificationItem | null = null;
        let index: number = -1;
        //for (let x = 0, y = notifications.length; x < y; x++) {
        //    if (notifications[x] === e.target()) {
        //        notification = notifications[x];
        //        index = x;
        //        break;
        //    }
        //}
        //if (notification != null) {
        //    notificationHolder.removeSubView(notification);
        //    notifications.splice(index, 1);
        //}
    }
    
    waitingForCall = function (): void {
        //if (this.isOpen()) {
            //cls.cl().main().mainController().profileStatus().setAgentStatus(11);
            if (!this.statusSet) {
                // im.DataService.instance().GetUserStatus({ queueID: this.queueID }, function (statusID: number) {
                this.tmQueueService.getUserStatus(this.queueID).subscribe(res => {
                    if (res.Response.Data !== 6) {
                        this.appService.setAgentStatus(6);
                        //im.DataService.instance().SetUserStatus({ statusID: 6, queueID: this.queueID }, function () {
                        this.tmQueueService.setUserStatus(6, this.queueID).subscribe(data => {
                            this.updateStatusSet(true);
                            this.waitingForCall();
                        });
                    } else {
                        this.updateStatusSet(true);
                        this.waitingForCall();
                    }
                });
                return;
            }
            if (this.waitingTimeout) {
                clearTimeout(this.waitingTimeout);
                this.waitingTimeout = null;
            }
           
            
            //im.InteractionService.instance().WaitingForCall({ queueID: this.queueID, agentCallID: this.callID }, successCallback, errorCallback);
            this.tmQueueService.waitingForCall(this.queueID, this.callID).subscribe(data => {
                //console.log("waitingForCall response", data);
                //this.callId = data.Response.Data.CallID;
                this.successCallback(data.Response.Data)
                //this.isInboundCallConnected();
            },
                this.errorCallback
            )
        //}
    }
    errorCallback = function (errorCode, details) {
        if (this.message === "Empty queue") {
            //im.UIAlert.open('There are no more records in this queue.');
        }
        else if (this.isOpen()) {
            if (details.indexOf("Error getting application lock") !== -1) {
                this.waitingTimeout = setTimeout(this.waitingForCall, 5000);
            } else if (retryCount < maxRetry) {
                retryCount++;
                //im.InteractionService.instance().WaitingForCall({ queueID: this.queueID, agentCallID: this.callID }, successCallback, errorCallback);
            } else {
                const message: string = 'An unknown error occurred while waiting for the next ' + this.interactionName.toLowerCase() + '.<br /><br />Press OK to reload the page.<br />If this error persists, please contact Onvida.';
                if (this.phoneController.phoneEnabled()) {
                    this.phoneController.showError(true, message, details);
                } else {
                    //im.UIAlert.open(message + '<br /><br />Error details: "' + details + '"', function () {
                    //    cls.cl().main().mainController().refresh();
                    //});
                }
            }
        }
    }
    successCallback = function (response) {
        //if (this.isOpen()) {
        if (response && response.Connecting === true && response.InteractionID) {
            //this.close();
            //if (this.activeController() === 'Dialog') {
            //    const dialogController = this.DialogController.instance();
            //    if (dialogController) {
            //        dialogController.requestTypeColor(response.Color);
            //        dialogController.requestType(response.RequestType);
            //    }
            //}
            //cls.redirect('Dialog/' + this.queueID + '-' + (response.Inbound ? 'inbound_i' : 'i') + response.InteractionID, false, true);
        } else if (response && response.UserID) {
            //this.close();
            let actionItemID: string = this.queueID + '-' + response.UserID + '-' + response.CaseID;
            actionItemID += (response.ScheduledInteractionID ? ('-si' + response.ScheduledInteractionID) : '');
            //cls.redirect('Dialog/' + actionItemID, false, true);
            //cls.cl().main().mainController().endCall();
            this.newCallSnd.play();
        } else {
            if (response.CallID != null)
                this.callID = response.CallID;
            if (this.callID == null && this.softPhone) {
                this.showPhoneMessaging('Connecting your softphone.<br />Please wait...');
                this.hideTimer();
            }
            this.waitingTimeout = setTimeout(this.waitingForCall, 5000);
        }
        //}
    };
    checkCallConnected = function (): void {
        //clearTimeout(checkConnectedTimer);
        //if (cls.isOpen()) {
        //    let retryCount: number = 0;
        //    const maxRetry: number = 2;
        //    const errorCallback = function (errorCode: number, details: string): void {
        //        if (retryCount < maxRetry) {
        //            retryCount++;
        //            im.InteractionService.instance()[inbound ? 'IsInboundCallConnected' : 'IsPredictiveCallConnected'](successCallback, errorCallback);
        //        } else {
        //            const message: string = 'An unknown error occurred while waiting for the next ' + interactionName.toLowerCase() + '.<br /><br />Press OK to reload the page.<br />If this error persists, please contact Onvida.';
        //            if (phoneController.phoneEnabled()) {
        //                phoneController.showError(true, message, details);
        //            } else {
        //                im.UIAlert.open(message + '<br /><br />Error details: "' + details + '"', function () {
        //                    cls.cl().main().mainController().refresh();
        //                });
        //            }
        //        }
        //    };
        //    const successCallback = function (response: any): void {
        //        if (cls.isOpen()) {
        //            const isConnected: boolean = response.Connected;
        //            const isInbound: boolean = response.Inbound;
        //            const theQueueID: string = response.QueueID;
        //            interactionID = response.InteractionID;
        //            if (isConnected) {
        //                cls.close();
        //                cls.redirect('Dialog/' + theQueueID + '-' + (isInbound ? 'inbound_' : '') + 'i' + interactionID + '-0' + (theQueueID === queueID ? '' : ('-' + queueID)), false, true);
        //            } else
        //                checkConnectedTimer = setTimeout(checkCallConnected, 3000);
        //        }
        //    };
        //    im.InteractionService.instance()[inbound ? 'IsInboundCallConnected' : 'IsPredictiveCallConnected'](successCallback, errorCallback);
        //}
    }

    showPhoneMessaging = function (message: string): void {
        //if (phoneController.phoneEnabled()) {
        //    phoneController.showMessage(true, {
        //        message: message,
        //        type: im.PhoneView.MessageTypes.INFO,
        //        btn1OnClick: eCancelClickHandler
        //    });
        //} else {
        //    waitMsg.text(message);
        //}

    }

    eCancelClickHandler = function (e: any): void {
        //if (inbound) {
        //    cls.close();
        //    cls.cl().main().mainController().setStatusAway();
        //    cls.cl().main().mainController().endCall();
        //} else {
        //    const confirmCallback = function (): void {
        //        cls.close();
        //        im.DataService.instance().PredictiveWaitCancelled();
        //        cls.cl().main().mainController().setStatusAway();
        //        cls.cl().main().mainController().endCall();
        //    }
        //    if (phoneController.phoneEnabled()) {
        //        phoneController.showConfirm(true, 'This may result in an abandoned ' + interactionName.toLowerCase() + '. Are you sure you would like to cancel?', confirmCallback);
        //    } else {
        //        if (alertBox == null) {
        //            alertBox = new im.UIAlert();
        //            alertBox.continueLabel('Yes').cancelLabel('No').destroyOnClose(false);
        //        }
        //        alertBox.open('This may result in an abandoned ' + interactionName.toLowerCase() + '.  Are you sure you would like to cancel?', confirmCallback, function () {
        //            alertBox.close();
        //        });
        //    }
        //}
    }
    ngOnDestroy = function (): void {
        this.checkConnectedTimer && window.clearTimeout(this.checkConnectedTimer);
        this.pendingTimer && window.clearTimeout(this.pendingTimer);
        this.waitingTimeout && window.clearTimeout(this.waitingTimeout);
    }
}


/*export { PredictiveWaitBlocker };*/
